import React from "react";

//UI Material
import { Button, Stack, TableCell, TableRow, Typography } from "@mui/material";

//Local components
import { ArrowForwardIos } from "@mui/icons-material";

const types = ["Física", "Jurídica", "Otra", "Sin asignar"];

export default function ClientRow({ client }) {
  // ==========> Component <==========
  return (
    <TableRow>
      <TableCell align="center">
        <Typography>{client.id}</Typography>
      </TableCell>
      <TableCell align="center" sx={{ width: "250px" }}>
        <Typography>{client.name}</Typography>
      </TableCell>
      <TableCell align="center">
        {client.idDocument === "Sin asignar" || client.idDocument === "" ? (
          "Sin asignar"
        ) : (
          <Stack>
            <Typography>{client.idDocument}</Typography>
            <Typography>{`${types[client.type]}`}</Typography>
          </Stack>
        )}
      </TableCell>
      <TableCell align="center">
        <Typography>{client.phoneNumber || "Sin asignar"}</Typography>
      </TableCell>
      <TableCell align="center">
        <Typography>{client.email || "Sin asignar"}</Typography>
      </TableCell>
      <TableCell align="center">
        <Typography>
          {`${client.address} ${client.province} ${client.country}`}
        </Typography>
      </TableCell>
      <TableCell align="center">
        <Button
          onClick={() => {
            window.location.href = `/client?id=${client.id}`;
          }}
          endIcon={<ArrowForwardIos />}
        >
          VER CLIENTE
        </Button>
      </TableCell>
    </TableRow>
  );
}
